import React from 'react';

const LoadingSpinner: React.FC = () => (
  <div className="flex flex-col items-center justify-center min-h-[200px]">
    <div className="relative w-12 h-12">
      <div className="absolute inset-0 rounded-full border-4 border-blue-500 border-t-transparent animate-spin"></div>
      <div className="absolute inset-2 rounded-full border-2 border-blue-200 border-t-transparent animate-spin-slow"></div>
    </div>
    <span className="mt-4 text-blue-600 font-semibold text-lg tracking-wide animate-pulse">
      Φόρτωση...
    </span>
  </div>
);

export default LoadingSpinner;

// Extra Tailwind animation (προαιρετικά στο tailwind.config.js):
// theme: {
//   extend: {
//     animation: {
//       'spin-slow': 'spin 2s linear infinite',
//     },
//   },
// },
